import React from "react";
import { Factory, BadgeDollarSign, ShieldCheck } from "lucide-react";

const POINTS = [
  {
    Icon: Factory,
    title: "Work Directly With The Manufacturer",
    body:
      "Skip the dealer chain. Talk to the team that designs, engineers, and builds every ViewLux opening.",
  },
  {
    Icon: BadgeDollarSign,
    title: "Save Up To 50%",
    body:
      "Factory-direct pricing means you pay for the product, not traditional distributor markups stacked on top.",
  },
  {
    Icon: ShieldCheck,
    title: "NFRC & AAMA Certified",
    body:
      "Every system carries the NFRC label and the AAMA Gold Label — independently verified structural, thermal, and air performance.",
  },
];

export default function ValueBar() {
  return (
    <section
      data-testid="value-bar"
      id="why-direct"
      aria-label="Why ViewLux"
      className="relative bg-[#0f2420] text-white border-y border-[#c99658]/20"
    >
      <div className="container-vlx py-14 md:py-20">
        <ul className="grid md:grid-cols-3 gap-px bg-[#c99658]/15">
          {POINTS.map((p, i) => (
            <li
              key={p.title}
              data-testid={`value-${i}`}
              className="group bg-[#0f2420] flex flex-col items-start gap-5 p-8 md:px-10 md:py-12 transition-colors duration-500 hover:bg-[#16332d]"
            >
              <div className="flex items-center gap-4">
                <span className="w-12 h-12 inline-flex items-center justify-center rounded-full border border-[#c99658]/40 text-[#e2b880] group-hover:bg-[#c99658] group-hover:text-[#0f2420] group-hover:border-[#c99658] transition-colors">
                  <p.Icon className="w-5 h-5" strokeWidth={1.5} />
                </span>
                <span className="text-[10.5px] tracking-[0.45em] uppercase font-raleway text-[#e2b880]">
                  0{i + 1}
                </span>
              </div>
              <h2 className="heading-lg text-[22px] md:text-[26px] text-white leading-[1.15]">
                {p.title}
              </h2>
              <p className="text-white/65 text-[14px] leading-[1.85] font-nunito">
                {p.body}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
